import React from 'react';
import { Breadcrumb, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import BreadcrumbsPortal from '@rd-web-markets/shared/dist/util/BreadcrumbsPortal';
import MasterSidebar from '@rd-web-markets/shared/dist/util/MasterSidebar';
import Rates from '@rd-web-markets/market/dist/rates/Rates'

export default function RatesPage () {
  return (
    <>
      <BreadcrumbsPortal>
        <Breadcrumb>
          <Breadcrumb.Item linkAs={Link} linkProps={{to: '/admin'}}>Home</Breadcrumb.Item>
          <Breadcrumb.Item active>Rates</Breadcrumb.Item>
        </Breadcrumb>
      </BreadcrumbsPortal>

      <Row className='justify-content-center mx-0 mt-4'>
        <Col md={10}>
          <Rates />
        </Col>
      </Row>
    </>
  );
}
